import { createContext, useContext } from 'react';

import { defaultOptimizelyFlags } from '../flags';
import { OptimizelyFlagKeys, OptimizelyFlags } from '../types';

export const OptimizelyFlagContext = createContext<OptimizelyFlags>(defaultOptimizelyFlags);

export function useOptimizelyFlags(flags: OptimizelyFlagKeys[]): OptimizelyFlags {
  const allFlags = useContext(OptimizelyFlagContext);

  if (!flags || flags.length === 0) {
    return allFlags;
  }

  const selectedFlags = {} as OptimizelyFlags;

  flags.forEach((flag) => {
    if (flag in allFlags) {
      selectedFlags[flag] = allFlags[flag];
    }
  });

  return selectedFlags;
}
